module.exports = __webpack_public_path__ + "assets/alert.78098746.svg";